import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    padding: 20,
    marginBottom: 13,
    borderRadius: 8,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  cardQuestion: {
    fontSize: 14,
    marginBottom: 20,
  },
  chipsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  imgContainer: {
    width: '100%',
    maxWidth: 33,
    height: 33,
    marginRight: 16,
    border: `3px solid ${theme.colors.light.ghostWhite}`,
    borderRadius: 8,
    position: 'relative',
  },
  img: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
  question: {
    fontSize: theme.fonts.sizes.font12PX,
  },
  buttonGroup: {
    display: 'flex',
  },
}));
